import styled from 'styled-components'


export const Layout=styled.div`
// height: 100%;
display: flex;
color: #ce9083;
// max-width: fit-content;
font-family: "Barlow";
background-size: 100% 100%;
background-position: center;
background-repeat: no-repeat;
background-image: url(../image/bg-pattern-desktop.svg);

@media(max-width: 800px){
  display: flex;
  // max-width: 600px;
  flex-direction: column;
  background-color:  rgb(255,249,249);
}

@media(max-width: 500px){
  display: flex;
  // max-width: 500px;
  flex-direction: column;
  background-color:  rgb(255,249,249);
}


@media(max-width: 1200px){

}

`

export const Picture=styled.div`
order: 2;
  .productImage{
    width: 100%;
    height: 100%;
    object-fit: cover;

    @media(max-width: 500px){
      height: 70%;
      width: 50%
      object-fit: cover;
    }


@media(max-width: 500px){
  order: 2;
  display: block;
}

@media(max-width: 800px){
  order: 2;
  display: block;
}

`

export const Productcontent =styled.div`
@media(max-650px){
  display: none;
}
`

export const LogoWrapper=styled.div`
padding: 96px;


@media(max-width: 650px){
  order: 1;
}

@media(max-width: 650px){
  padding: 50px;
}
`

export const Logo=styled.img`
width: 50%;
height: 100%;

@media(max-width: 370px){
  width: 50%
  height: fit-content;
 }
`

export const Content = styled.div`
padding-left: 86px;
padding-right: 86px;
max-width: 700px;
display: flex;
order: 1;
flex-direction: column;

@media(min-width: 1200px){
  
  
}

@media(max-width: 650px){
  order:2;
  align-items: center;
  max-width: 550px;
  padding-left: 50px;
  padding-right: 50px;
}

@media(max-width: 370px){
  order: 2;
  max-width: 400px;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
 }
`

export const Title=styled.h1`
font-weight: 400;
font-size: 3.5rem;
margin-bottom: 1rem;
line-height: 3.9rem;
letter-spacing: 1.5rem;
font-family: 'Montserrat';
text-transform: uppercase;

b{
  color: #1c1b1b;
}

@media(max-width: 800px){
  font-size: 2.3rem;
  margin-bottom: 1rem;
  text-align: center;
}

@media(max-width: 650px){
  font-size: 2.5rem;
  text-align: center;
}

@media(max-width: 370px){
  font-size: 1.3rem;
  line-height: 2.7rem;
 }
`

export const Subtitle=styled.p`
font-size: 1rem;
line-height: 2rem;
margin-bottom: 2rem;
font-family: 'Barlow';

@media(max-width: 370px){
  font-size: .7rem;
  text-align: center;
}

@media(max-width: 600px){
  font-size: .9rem;
  text-align: center;
}
`

export const Form=styled.form`
width: 100%;
display: flex;
border: none;
cursor: pointer;
height: inherit;
position: relative;
margin-bottom: 2rem;
border-radius: 30px;
border: 1px solid  #ffcccb;

&:hover{
  outline: none;
  border: 1px solid  #d10000;
}

.error-icon{
  width: 20px;
  height: 20px;
  top: 40%;
  bottom: 40p%;
  margin-top: 1rem;
  margin-right: .5rem;
}
`

export const Input=styled.input`
width: 100%;
border: none;
color: #1c1b1b;
cursor: pointer;
padding: 15px 30px;
background-color: inherit;

&::placeholder{
  color: #ffcccb;

  @media(max-width: 370px){
    font-size: .6rem;
    
  }
}

&:focus{
  outline: none;
  
}

.form-control{
  margin: 5px 0 0;
  display: inline-block;
}

`

export const Button=styled.button`
border: none;
height: 50px;
cursor: pointer;
padding: 17px 35px;
border-radius: 30px;
background-color: #ce9083;

&:hover{
  opacity: 0.7;
}

@media(max-width: 370px){
  padding: 15px 32px;
}
`

export const Feedback=styled.div`
position: relative;
display: block;
margin: 5px 0 0;
font-size: .8rem;
text-align: left;
color: #d10000;
font-weight: 500;
margin-left: 1rem;
margin-bottom: 3rem;

`